import React, { Component } from 'react';
import { Dropdown, Input, Divider, Button, Grid } from 'semantic-ui-react';
import _ from 'lodash';

import './ModalAdSetDAA.css';

class ModalAdSetDAA extends Component {
  state = {
    showFields: false,
    selectedAudiences: [],
    form: {
      id: null,
      title: '',
      placement: '',
      daaAdsetType: '',
      location: '',
      audience: '',
      targeting: '',
      audiences: []
    }
  };

  componentDidMount() {
    if (this.props.adsetToEdit) {
      this.initializeEdit(this.props.adsetToEdit);
    }
  }

  fillInclude = () => {
    const includeOptions = [];
    includeOptions.push({ key: 0, value: true, text: 'Include' });
    includeOptions.push({ key: 1, value: false, text: 'Do not Include' });

    this.setState({ includeOptions });
  };

  initializeEdit = async (adsetToEdit) => {
    const {
      id,
      daaType,
      includeLocation,
      includeAudience,
      includeTargeting,
      selectedAudiences
    } = adsetToEdit;
    const nameParts = adsetToEdit.adSetName.split('_');
    const form = {
      ...this.state.form,
      id,
      title: nameParts[nameParts.length - 2],
      placement: nameParts[nameParts.length - 1],
      daaAdsetType: daaType,
      location: includeLocation,
      audience: includeAudience,
      targeting: includeTargeting,
      languages: null,
      positions: null,
      devices: null,
      gender: null,
      ageFrom: null,
      ageTo: null,
      optimizationGoal: null,
      audiences:
        selectedAudiences && selectedAudiences.length > 0
          ? selectedAudiences.map((audience) => audience.value)
          : []
    };

    const showFields =
      adsetToEdit.daaType === 'Retargeting' || adsetToEdit.daaType === 'Broad';

    this.setState({ ...this.state, form, showFields });
  };

  saveAdSet = () => {
    const { campaignName } = this.props;
    const { selectedAudiences, form } = this.state;
    const {
      id,
      title,
      placement,
      daaAdsetType,
      location,
      audience,
      targeting
    } = form;

    const adset = {
      id,
      adSetName: `${campaignName}_${title}_${placement}`,
      gender: null,
      ageFrom: null,
      ageTo: null,
      optimizationGoal: null,
      languages: null,
      positions: null,
      devices: null,
      daaType: daaAdsetType,
      includeLocation: location,
      includeAudience: audience,
      includeTargeting: targeting,
      selectedAudiences
    };

    this.props.addAdset(adset);
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  onSelection = (event, data) => {
    const id = data.id;
    const item = _.find(data.options, (option) => {
      return option.value === data.value;
    });

    const form = { ...this.state.form };
    form[id] = item.value;

    if (!this.props.adsetToEdit) {
      if (item.value === 'Retargeting') {
        form.location = false;
        form.audience = false;
        form.targeting = false;
      } else {
        form.location = true;
        form.audience = false;
        form.targeting = false;
      }
    }

    this.setState({ ...this.state, form, showFields: true });
  };

  onAudienceSelectAdset = async (event, { value, options }) => {
    const audiences = [];

    value.forEach((val) => {
      const audience = _.find(options, (option) => {
        return option.value === val;
      });

      if (audience) {
        audiences.push(audience);
      }
    });

    const formAudiences = value;

    this.setState({
      ...this.state,
      selectedAudiences: audiences,
      form: { ...this.state.form, audiences: formAudiences }
    });
  };

  render() {
    const adsetTypes = [
      { key: 0, value: 'Retargeting', text: 'Retargeting' },
      { key: 1, value: 'Broad', text: 'Broad' }
    ];
    const includeOptions = [
      { key: 0, value: true, text: 'Include' },
      { key: 1, value: false, text: 'Do not Include' }
    ];
    const { audienceOptions } = this.props;
    const { form, showFields } = this.state;
    const {
      title,
      placement,
      daaAdsetType,
      location,
      audience,
      targeting,
      audiences
    } = form;

    return (
      <div className="daa-modal-adset-container">
        <Input
          className="daa-modal-adset-title"
          placeholder="Title"
          type="text"
          name="title"
          value={title}
          onChange={this.handleFormChange}
        />
        <Input
          placeholder="Placement"
          type="text"
          name="placement"
          value={placement}
          onChange={this.handleFormChange}
        />
        <Divider hidden />
        <Dropdown
          placeholder="Type"
          search
          selection
          id="daaAdsetType"
          value={daaAdsetType}
          options={adsetTypes}
          onChange={this.onSelection}
        />
        <Divider hidden />
        {showFields ? (
          <Grid>
            <Grid.Row columns={2}>
              <Grid.Column>
                <span>Placements:</span>
              </Grid.Column>
              <Grid.Column>
                <b className="daa-modal-Label">All Placements</b>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <span>Vehicle Set:</span>
              </Grid.Column>
              <Grid.Column>
                <b className="daa-modal-Label">Selected at Launch</b>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <span>Event Source Group:</span>
              </Grid.Column>
              <Grid.Column>
                <b className="daa-modal-Label">
                  Created at Launch. Client Pixel Event. Source Group
                </b>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <span>
                  {daaAdsetType === 'Retargeting' ? 'Inclusion:' : 'Exclusion:'}
                </span>
              </Grid.Column>
              <Grid.Column>
                <b className="daa-modal-Label">
                  Client Pixel Event. Source Group
                </b>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <span>Conversion Window:</span>
              </Grid.Column>
              <Grid.Column>
                <b className="daa-modal-Label">7-day click or 1-day view</b>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <span>Location:</span>
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  placeholder="Location"
                  search
                  selection
                  id="location"
                  value={location}
                  options={includeOptions}
                  onChange={this.onSelection}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <span>Custom Audiences:</span>
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  placeholder="Custom Audiences"
                  search
                  selection
                  id="audience"
                  value={audience}
                  options={includeOptions}
                  onChange={this.onSelection}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row columns={2}>
              <Grid.Column>
                <span>Detailed Targeting:</span>
              </Grid.Column>
              <Grid.Column>
                <Dropdown
                  placeholder="Detailed Targeting"
                  search
                  selection
                  id="targeting"
                  value={targeting}
                  options={includeOptions}
                  onChange={this.onSelection}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        ) : null}
        <Divider hidden />
        <Dropdown
          placeholder="Audiences"
          search
          multiple
          selection
          name="audiences"
          className="launch-package-audiences"
          value={audiences}
          options={audienceOptions}
          onChange={this.onAudienceSelectAdset}
        />
        <Divider hidden />
        <Button
          onClick={this.props.onCloseModalAdset}
          size="small"
          color="grey"
        >
          Cancel
        </Button>
        <Button onClick={this.saveAdSet} size="small" color="blue">
          Save
        </Button>
      </div>
    );
  }
}

export default ModalAdSetDAA;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/ModalAdSetDAA.js